import { render, staticRenderFns } from "./EventPackage.vue?vue&type=template&id=53284b66&scoped=true"
import script from "./EventPackage.vue?vue&type=script&lang=js"
export * from "./EventPackage.vue?vue&type=script&lang=js"
import style0 from "./EventPackage.vue?vue&type=style&index=0&id=53284b66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53284b66",
  null
  
)

export default component.exports